import { updateItems } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '新剧上线': 'bg-primary-100 text-primary-700',
  '电影更新': 'bg-accent-100 text-accent-700',
  '综艺更新': 'bg-secondary-100 text-secondary-700',
  '同步更新': 'bg-primary-100 text-primary-700',
  '动漫上线': 'bg-accent-100 text-accent-700',
  '平台公告': 'bg-secondary-100 text-secondary-700',
  '专题上线': 'bg-primary-100 text-primary-700',
  '海外同步': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3">
            实时快讯
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            更新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            芭乐视频每日内容更新一览，最新剧集电影综艺动漫同步
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-start gap-4 py-5 ${
                i < updateItems.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div className="flex-shrink-0 w-24 text-right">
                <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
              </div>
              <div className="flex-shrink-0 flex flex-col items-center pt-1">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                {i < updateItems.length - 1 && (
                  <div className="w-px h-full bg-background-300 mt-1"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <span className={`inline-block px-2 py-0.5 text-[10px] font-medium rounded-full ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'} mb-1.5 whitespace-nowrap`}>
                  {item.tag}
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}